import { APP_NAME } from "utility";

export const CustomImage = ({ src = "", title = "", alt = "", ...props }) => {
  return <img src={src ?? ""} alt={alt || title || APP_NAME} {...props} />;
};
